__turbopack_context__.v({
  "navigationListItem": "styles-module__hOAP-q__navigationListItem",
  "navigationListItem--lgUp": "styles-module__hOAP-q__navigationListItem--lgUp",
  "navigationListItem--mdDown": "styles-module__hOAP-q__navigationListItem--mdDown",
  "navigationListItem--mdUp": "styles-module__hOAP-q__navigationListItem--mdUp",
  "navigationListItem--smUp": "styles-module__hOAP-q__navigationListItem--smUp",
});
